import React, { useState, useEffect, useMemo } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardImg,
  Col,
  Row,
  Spinner,
} from "reactstrap";
import image1 from "../../../../assets/orderingSystem/burger.jpeg";
import { Link } from "react-router-dom";
import CustomerForm from "./component/CustomerForm";
import CustomerList from "./component/CustomerList";
import toast from "react-hot-toast";
import OrderServices from "../../../../services/OrderingServices/OrderServices";
import restro from "../../../../assets/orderingSystem/restrologo.png";
import ConfirmPayment from "./component/ConfirmPayment";
import PrintBillModal from "./component/PrintBillModal";
import PaymentMethod from "./component/PaymentMethod";
import InvoiceBillModal from "./component/InvoiceBillModal";
import KOTModal from "./component/KOTModal";
import CancelOrder from "./component/CancelOrder";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteOrderItems,
  deleteUnplacedOrderItems,
  resetOrder,
} from "../../../../slices/Order/orderSlice";
import { getLoggedInUser } from "../../../../helpers/fakebackend_helper";
import TableSelect from "../Table/page/TableSelect";
import TableSwitch from "../Table/page/TableSwitch";
import TableMerge from "../Table/page/TableMerge";
import TableService from "../../../../services/OrderingServices/TableService";
// Placeholder image (replace with actual import if available)

const OrderSummary = ({
  orderData,
  setIsQuantityChanged,
  isQuantityChanged,
  data,
  fetchTable,
  sectionData,
  setSelectedSection,
  selectedSection,
  fetchOrder,
  handlePlaceOrder,
  setSelectedTable,
  selectedTable,
  itemCounts,
  setItemCounts,
  placedLoading,
  placedItems,
  fetchKot,
  allTables
}) => {
  console.log("🚀 ~ OrderSummary ~ sectionData:", sectionData);
  const orderId = orderData?.[selectedTable?.id]?.orderId;
  console.log("orderIdddddd", orderId);
  const [selectedCustomer, setSelectedCustomer] = useState(
    JSON.parse(localStorage.getItem("selectedCustomer")) || null
  );

  const user = JSON.parse(localStorage.getItem("user")) || {};

  const isBackery = user?.user?.shouldShowTable;

  const orgInfo = user?.organizationInfo || {};
  const localuser = JSON.parse(localStorage.getItem("user")) || {};
  const userInfo = localuser?.user || {};
  const [isListOpen, setIsListOpen] = useState(false);
  const [isTableOpen, setIsTableOpen] = useState(true);
  const [isSwitchOpen, setIsSwitchOpen] = useState(false);
  const [isMergeOpen, setIsMergeOpen] = useState(false);
  const [isSwitchItemOpen, setIsSwitchItemOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [promoCode, setPromoCode] = useState("");
  const [promoError, setPromoError] = useState("");
  const [promoSuccess, setPromoSuccess] = useState("");
  const [error, setError] = useState(null);
  const [isRight, setIsRight] = useState(false);
  console.log("🚀 ~ OrderSummary ~ isRight:", isRight);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedPayments, setSelectedPayments] = useState([]);
  console.log("🚀 ~ OrderSummary ~ selectedPayments:", selectedPayments);
  const [selectedPayment, setSelectedPayment] = useState([]);
  const [invoiceCustomer, setInvoiceCustomer] = useState(null);

  const [isPaymentModal, setIsPaymentModal] = useState(false);
  const [discountPercent, setDiscountPercent] = useState("");
  const [discountAmount, setDiscountAmount] = useState("");
  const [lastUpdated, setLastUpdated] = useState(null);
  const [isKOTOpen, setIsKOTOpen] = useState(false);
  const [responseData, setResponseData] = useState();
  const [creditData, setCreditData] = useState();
  console.log("🚀 ~ OrderSummary ~ creditData:", creditData);
  const [paymentAmounts, setPaymentAmounts] = useState({});
  const [invoicePayments, setInvoicePayments] = useState([]);

  const toggleKOT = () => setIsKOTOpen(!isKOTOpen);

  const togglePayment = () => setIsPaymentModal(!isPaymentModal);
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  const toggleListModal = () => setIsListOpen(!isListOpen);
  const toggleTableModal = () => setIsTableOpen(!isTableOpen);
  const toggleSwitchModal = () => setIsSwitchOpen(!isSwitchOpen);
  const toggleMergeModal = () => setIsMergeOpen(!isMergeOpen);
  const toggleSwitchItemModal = () => setIsSwitchItemOpen(!isSwitchItemOpen);
  const [isTakeawayPaymentPending, setIsTakeawayPaymentPending] =
    useState(false);
  const [selectedAttributes, setSelectedAttributes] = useState([]);

  const toggleRightCanvas = () => {
    if (isTakeawayPaymentPending) {
      toast.error("Please complete the payment before closing.");
      return;
    }
    setIsRight(!isRight);
  };

  const dispatch = useDispatch();
  const authUser = getLoggedInUser();
  // console.log("authUserr", authUser);
  const userRole = authUser?.user?.roles[0]?.toLowerCase();

  const handleApplyPromo = () => {
    if (!promoCode.trim()) {
      setPromoSuccess("");
      setPromoError("Please enter a promo code.");
      toast.error("Please enter a promo code.");
      return;
    }
    if (promoCode.toLowerCase() === "save10") {
      if (promoSuccess) {
        setPromoError("Promo code already applied.");
        toast.error("Promo code already applied.");
        return;
      }
      setPromoError("");
      setPromoSuccess("Promo applied! 10% discount.");
      toast.success("Promo applied! 10% discount.");
      setPromoCode("");
      setDiscountPercent("10");
      setLastUpdated(null);
      setDiscountAmount((calculateTotals.subTotal * 0.1).toFixed(2));
    } else {
      setPromoSuccess("");
      setPromoError("Invalid promo code.");
      toast.error("Invalid promo code.");
    }
  };

  const handleCheckboxChange = (itemKey) => {
    setSelectedItems((prev) =>
      prev.includes(itemKey)
        ? prev.filter((key) => key !== itemKey)
        : [...prev, itemKey]
    );
  };

  const [remarks, setRemarks] = useState();
  const [touched, setTouched] = useState();
  const isInvalid = touched && !remarks?.trim();

  const handleTakeawayOrder = async () => {
    await handlePlaceOrder();

    const takeaway = orderData["takeaway"];
    if (takeaway && takeaway.items.length > 0) {
      setIsRight(true);
      setIsTakeawayPaymentPending(true); // 🔒 Payment pending
      toast("Complete payment before closing", { icon: "💳" });
    }
  };

  const handleDeleteItem = async () => {
    if (selectedItems.length === 0) {
      toast.error("No items selected for deletion.");
      return;
    }

    if (!remarks?.trim()) {
      setTouched(true);
      return;
    }

    try {
      const tableId = selectedTable?.id || null;

      const itemIndexes = selectedItems.map((key) => {
        const [orderIndex, itemIndex] = key.split("-").map(Number);
        return { orderIndex, itemIndex };
      });

      if (tableId === null || tableId === "takeaway") {
        dispatch(
          deleteUnplacedOrderItems({ tableId: "takeaway", itemIndexes })
        );
        toast.success("Selected item(s) deleted.");
        fetchOrder();
        setSelectedItems([]);
        setRemarks("");
        setTouched(false);
        toggleDeleteModal();
        return;
      }

      const order = orderData[tableId] || orderData["takeaway"];
      console.log("🚀 ~ handleDeleteItem ~ order:", order);

      // Separate local and placed items
      const localItems = [];
      const placedItems = [];

      itemIndexes.forEach(({ orderIndex, itemIndex }) => {
        const item = orderData[orderIndex].items[itemIndex];
        if (item.isLocalItem) {
          localItems.push({ orderIndex, itemIndex });
        } else {
          placedItems.push(item.id); // API needs only the IDs
        }
      });

      // Delete local items
      if (localItems.length > 0) {
        dispatch(deleteOrderItems({ tableId, itemIndexes: localItems }));
      }

      // Delete placed items via API
      if (placedItems.length > 0) {
        await OrderServices.mulipleOrderCancel(tableId, placedItems, remarks);
        dispatch(deleteOrderItems({ tableId, itemIndexes }));
      }

      fetchOrder();
      setSelectedItems([]);
      setRemarks("");
      setTouched(false);
      toast.success("Selected items removed from order.");
      toggleDeleteModal();

      const isFromApp = navigator.userAgent.includes("CloudRestroAPK");
      console.log("Something", isFromApp);
      const isSettingMatched = true;

      console.log("Transform", isSettingMatched);

      if (isFromApp && isSettingMatched) {
        console.log("Running inside APK WebView");
        const userData = JSON.parse(localStorage.getItem("user") || "{}");
        const token = userData.accessToken || userData.token || null;
        console.log("This is the token: ", token);
        const printerData = { tableId: tableId || null, Token: token };
        console.log("It is printer data to be sent: ", printerData);
        const payload = encodeURIComponent(JSON.stringify(printerData));
        console.log("It is payload before sending to api: ", payload);
        window.location.href = `app://printKOT?data=${payload}`;
      } else {
        console.log("Running in normal browser 1");
      }
    } catch (error) {
      console.error("Error deleting items:", error);
      toast.error("Failed to remove items.");
    }
  };

  const filteredOrders = useMemo(() => {
    const ordersArray = Object.values(orderData);
    return selectedTable
      ? ordersArray.filter((order) => order.tableId === selectedTable.id)
      : ordersArray;
  }, [orderData, selectedTable]);
  console.log("🚀 ~ OrderSummary ~ filteredOrders:", filteredOrders);

  const calculateTotals = useMemo(() => {
    console.log("🔍 Calculating totals with:", {
      filteredOrders: filteredOrders.length,
      itemCounts,
      promoSuccess,
      discountPercent,
      discountAmount,
      lastUpdated,
      selectedCustomer: selectedCustomer?.firstName,
    });

    let subTotal = 0;

    filteredOrders.forEach((order) => {
      order.items.forEach((item, index) => {
        const itemId = `${order.tableId}-${index}`;
        const count = itemCounts[itemId] ?? item.quantity ?? 0;

        // // --- Determine price: either productPrice or attribute values ---
        // let itemPrice = 0;

        // if (item.productPrice != null) {
        //   itemPrice = item.productPrice;
        // } else if (
        //   Array.isArray(item.attributes) &&
        //   item.attributes.length > 0
        // ) {
        //   // Sum up attribute values (in case there are multiple)
        //   itemPrice = item.attributes.reduce(
        //     (sum, attr) => sum + (parseFloat(attr.value) || 0),
        //     0
        //   );
        // }

        // // Add to subtotal
        // subTotal += itemPrice * count;

        let itemPrice = 0;

        if (item.productPrice != null && item.productPrice > 0) {
          itemPrice = item.productPrice;
        } else if (
          Array.isArray(item.attributes) &&
          item.attributes.length > 0
        ) {
          // Use the selected attribute, if defined
          const selectedAttr = item.attributes.find(
            (attr) => attr.id === item.selectedAttributeId
          );

          if (selectedAttr) {
            itemPrice = parseFloat(selectedAttr.value) || 0;
            console.log("🚀 ~ OrderSummary ~ itemPrice:", itemPrice);
          } else {
            // fallback: if no attribute selected, take first active one
            const firstActive = item.attributes.find((attr) => attr.isActive);
            itemPrice = firstActive ? parseFloat(firstActive.value) || 0 : 0;
          }
        }

        // Add to subtotal
        subTotal += itemPrice * count;
      });
    });

    // --- Discount logic ---
    let discount = 0;
    let effectiveDiscountPercent = 0;

    if (promoSuccess) {
      discount = subTotal * 0.1;
      effectiveDiscountPercent = 10;
    } else if (lastUpdated === "amount" && discountAmount) {
      discount = parseFloat(discountAmount) || 0;
      effectiveDiscountPercent = (discount / subTotal) * 100;
    } else if (lastUpdated === "percent" && discountPercent) {
      effectiveDiscountPercent = parseFloat(discountPercent) || 0;
      discount = (effectiveDiscountPercent / 100) * subTotal;
    } else if (
      selectedCustomer?.customerTypeDiscount &&
      !lastUpdated &&
      !promoSuccess
    ) {
      effectiveDiscountPercent =
        parseFloat(selectedCustomer.customerTypeDiscount) || 0;
      discount = (effectiveDiscountPercent / 100) * subTotal;
    }

    // --- Ensure values stay valid ---
    discount = Math.min(discount, subTotal);
    const total = Math.max(0, subTotal - discount);

    console.log("💰 Totals:", { subTotal, discount, total });

    return {
      subTotal,
      discount,
      total,
      effectiveDiscountPercent,
    };
  }, [
    filteredOrders,
    itemCounts,
    promoSuccess,
    discountPercent,
    discountAmount,
    lastUpdated,
    selectedCustomer,
  ]);

  console.log(calculateTotals);

  useEffect(() => {
    if (promoSuccess || lastUpdated) return;
    if (selectedCustomer?.customerTypeDiscount !== undefined) {
      const percent = parseFloat(selectedCustomer.customerTypeDiscount) || 0;
      const amount = (percent / 100) * calculateTotals.subTotal;
      setDiscountPercent(percent.toFixed(2));
      setDiscountAmount(amount.toFixed(2));
    } else {
      setDiscountPercent();
      setDiscountAmount();
    }
  }, [selectedCustomer, calculateTotals.subTotal, promoSuccess, lastUpdated]);

  useEffect(() => {
    if (discountAmount && !promoSuccess && lastUpdated === "amount") {
      const amount = parseFloat(discountAmount);
      if (!isNaN(amount) && amount >= 0 && amount <= calculateTotals.subTotal) {
        const percent = (amount / calculateTotals.subTotal) * 100;
        const newPercent = percent.toFixed(2);
        if (newPercent !== discountPercent) {
          setDiscountPercent(newPercent);
        }
      }
    }
  }, [discountAmount, calculateTotals.subTotal, promoSuccess, lastUpdated]);

  const handlePercentChange = (e) => {
    const value = e.target.value;
    setDiscountPercent(value);
    setLastUpdated("percent");
    setPromoSuccess("");
    setPromoError("");

    const percent = parseFloat(value);
    if (!isNaN(percent) && calculateTotals.subTotal) {
      const amount = ((percent / 100) * calculateTotals.subTotal).toFixed(2);
      setDiscountAmount(amount);
    } else {
      setDiscountAmount();
    }

    if (!value) {
      setDiscountAmount("");
      setLastUpdated(null);
    }
  };

  const handleAmountChange = (e) => {
    let value = e.target.value;

    // Allow empty field without breaking logic
    if (value === "") {
      setDiscountAmount("");
      setLastUpdated(null);
      setPromoSuccess("");
      setPromoError("");
      return;
    }

    // Convert to number safely
    const num = Number(value);
    if (isNaN(num)) return; // Prevent invalid numbers

    setDiscountAmount(num);
    setLastUpdated("amount");

    // If user types amount manually → clear percent
    setDiscountPercent("");
    setPromoSuccess("");
    setPromoError("");
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    if (isModalOpen) {
      setInvoiceCustomer(null);
    }
  };
  const [billInfo, setBillInfo] = useState();
  const [totalCalculate, setTotalCalculate] = useState();

  const takeawayOrderId = JSON.parse(localStorage.getItem("orderId"));
  console.log("takeawayOrderId@@@@", takeawayOrderId);
  const handleCheckout = async () => {
    if (!selectedTable?.id && !orderData["takeaway"]) {
      toast.error("Please select a table before checking out.");
      return;
    }
    if (!orderData || Object.keys(orderData).length === 0) {
      toast.error("No items in the order to checkout.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const creditPayment = selectedPayments.find((p) =>
        p.name.toLowerCase().includes("credit")
      );

      const creditLogs =
        creditPayment && creditData?.customerId && creditData?.amount
          ? {
              customerId: creditData.customerId,
              amount: creditData.amount,
              remarks: creditData.remarks,
            }
          : null;

      // Filter out Credit from multiplePayments
      const otherPayments = selectedPayments.filter(
        (p) => !p.name.toLowerCase().includes("credit")
      );

      const customerForInvoice = selectedCustomer
        ? { ...selectedCustomer }
        : null;

      // Calculate actual payment amounts, adjusting for overpayment
      const adjustedPaymentAmounts = { ...paymentAmounts };
      
      // Check if there's overpayment (return amount)
      const totalPaid = otherPayments.reduce((sum, p) => {
        return sum + (Number(paymentAmounts[p.id]) || 0);
      }, 0) + (creditPayment ? parseFloat(creditData?.amount || 0) : 0);
      
      const billTotal = calculateTotals.total;
      const returnAmount = totalPaid - billTotal;
      
      // If there's overpayment, reduce it from the last payment method
      if (returnAmount > 0 && otherPayments.length > 0) {
        const lastPaymentId = otherPayments[otherPayments.length - 1].id;
        const lastAmount = Number(paymentAmounts[lastPaymentId]) || 0;
        adjustedPaymentAmounts[lastPaymentId] = Math.max(0, lastAmount - returnAmount);
      }

      const payload = {
        orderId: takeawayOrderId || orderId,
        // If Credit exists, use its id; else use first other payment or 0
        paymentTypeId: creditPayment
          ? creditPayment.id
          : otherPayments[0]?.id || 0,
        multiplePayments: otherPayments.map((p) => ({
          paymentTypeId: p.id,
          amount: Number(adjustedPaymentAmounts[p.id]) || 0,
        })),
        ...(creditLogs ? { creditLogs } : {}),
      };

      if (discountAmount && parseFloat(discountAmount) !== 0) {
        payload.discountAmount = discountAmount;
      }

      if (discountPercent && parseFloat(discountPercent) !== 0) {
        payload.discountPercentage = discountPercent;
      }

      const response = await OrderServices.checkout(payload);
      console.log("🚀 ~ handleCheckout ~ response:", response);
      setInvoicePayments(selectedPayments);

      toast.success("Checkout successful!");
      setResponseData(response);
      setBillInfo(orderData);
      dispatch(resetOrder());
      setTotalCalculate(calculateTotals);
      setInvoiceCustomer(customerForInvoice);
      setIsModalOpen(true);
      setIsRight(false);
      fetchTable();
      fetchKot();
      setItemCounts({});
      setPromoCode("");
      setPromoError("");
      setPromoSuccess("");
      setDiscountPercent("");
      setDiscountAmount("");
      setCreditData({});
      setSelectedPayment(null);
      setSelectedTable(null);
      setSelectedCustomer(null);
      localStorage.removeItem("selectedTable");
      localStorage.removeItem("orderId");
      localStorage.removeItem("selectedCustomer");
      setIsTakeawayPaymentPending(false);
      setIsRight(false);
    } catch (error) {
      console.error("Checkout error:", error);
      toast.error("Failed to complete checkout. Please try again.");
      setError("Failed to complete checkout.");
    } finally {
      setLoading(false);
    }
  };

  const handleUnmergeTable = async (primaryTableId) => {
    if (!primaryTableId) {
      toast.error("Section ID is required to unmerge the table.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await TableService.unmergeTable(primaryTableId); // Call your API
      console.log("🚀 ~ handleUnmergeTable ~ response:", response);

      toast.success("Table unmerged successfully!");

      // Optionally refresh tables and orders after unmerge
      fetchTable(); // refresh table data
      fetchOrder(); // refresh order data for selected table
      setSelectedTable(null); // reset selected table if needed
      localStorage.removeItem("selectedTable");
    } catch (error) {
      console.error("Error unmerging table:", error);
      toast.error("Failed to unmerge table. Please try again.");
      setError("Failed to unmerge table.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedTable?.id) {
      setIsTableOpen(false);
    }
  }, []);

  const handlePrint = async () => {
    try {
      const response = await OrderServices.kotprint(selectedTable?.id);
      toast.success(response);
    } catch (error) {
      console.error("KOT print error:", error);
      toast.error("KOT print unsuccessful.");
    }
  };
  useEffect(() => {
    setSelectedItems([]);
  }, [selectedTable?.id]);
  useEffect(() => {
    setSelectedItems([]);
    setRemarks("");
    setTouched(false);
  }, [selectedTable?.id]);

  useEffect(() => {
    if (!isRight) {
      setPromoCode("");
      setPromoError("");
      setPromoSuccess("");
      setDiscountAmount("");
      setDiscountPercent("");
      // setSelected(null); // Reset local selected state
      setSelectedPayment(null); // Reset parent selectedPayment state
      setLastUpdated(null); // Reset last updated timestamp
      setSelectedPayments([]);
      setPaymentAmounts({});
      setCreditData({});
    }
  }, [
    isRight,
    // setSelectedPayment,
    // setPromoCode,
    // setPromoError,
    // setPromoSuccess,
    // setDiscountAmount,
    // setDiscountPercent,
    // setLastUpdated,
    // setSelectedPayments,
    // setPaymentAmounts,
    // setCreditData,
  ]);
  const currentOrder = selectedTable?.id ? orderData[selectedTable.id] : null;
  console.log("🚀 ~ OrderSummary ~ currentOrder:", currentOrder);
  const hasOrderId = currentOrder?.orderId; // Order has been placed
  const isNewItem = currentOrder?.isNewItem; // Flag for new items added
  const takeawayOrder = orderData.takeaway;
  const isTakeaway = takeawayOrder && takeawayOrder.items.length > 0;

  const getOrderButtonState = () => {
    if (
      !isTakeaway &&
      (!selectedTable ||
        !orderData[selectedTable.id] ||
        !orderData[selectedTable.id].items ||
        orderData[selectedTable.id].items.length === 0)
    ) {
      return {
        text: "Place Order",
        disabled: true,
        variant: "success",
        action: handlePlaceOrder,
      };
    }

    // if (!hasOrderId) {
    //   // New order
    //   return {
    //     text: "Place Order",
    //     disabled: false,
    //     variant: "success",
    //     action: handlePlaceOrder,
    //   };
    // }

    if (!hasOrderId) {
      const isTakeaway =
        orderData.takeaway && orderData.takeaway.items.length > 0;

      return {
        text: "Place Order",
        disabled: false,
        variant: "success",
        action: isTakeaway ? handleTakeawayOrder : handlePlaceOrder,
      };
    }

    if (hasOrderId && (isNewItem || isQuantityChanged)) {
      // Existing order but changed
      return {
        text: "Update Order",
        disabled: false,
        variant: "warning",
        action: handlePlaceOrder,
      };
    }

    // Order exists, no changes
    return {
      text: "Already Placed",
      disabled: true,
      variant: "secondary",
      action: () => {},
    };
  };

  const orderButtonState = getOrderButtonState();
  const [expandedItems, setExpandedItems] = useState({});
  const toggleChildren = (itemKey) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemKey]: !prev[itemKey],
    }));
  };
  const handleCardClick = (itemKey) => {
    // toggle children
    // toggleChildren(itemKey);

    // toggle selection
    handleCheckboxChange(itemKey);
  };

  return (
    <Card
      className="d-flex flex-column overflow-hidden rounded-4 shadow-sm"
      style={{ height: "97vh" }}
    >
      <Card className="border-0 shadow-sm mb-0 flex-shrink-0">
        <CardBody className="d-flex align-items-center justify-content-between flex-wrap gap-3">
          {isBackery && (
            <div
              className="d-flex align-items-center gap-2 cursor-pointer"
              onClick={toggleTableModal}
            >
              <i
                className="ri-restaurant-line fs-4 text-success"
                title="Select Table"
              ></i>
              <div>
                <div className="text-muted small">Table</div>
                <h6 className="mb-0 fw-bold cursor-pointer">
                  {selectedTable?.tableName || "Select Table"}
                </h6>
              </div>
            </div>
          )}

          <button
            onClick={toggleSwitchModal}
            disabled={!selectedTable?.id}
            className="btn btn-light d-flex flex-column align-items-center justify-content-center border-0 bg-transparent"
            style={{ cursor: !selectedTable?.id ? "not-allowed" : "pointer" }}
          >
            <div className="text-muted small">Switch</div>
            <i className="bx bx-repost fs-5 text-success cursor-pointer"></i>
          </button>
          <button
            onClick={toggleMergeModal}
            disabled={!selectedTable?.id}
            className="btn btn-light d-flex flex-column align-items-center justify-content-center border-0 bg-transparent"
            style={{ cursor: !selectedTable?.id ? "not-allowed" : "pointer" }}
          >
            <div className="text-muted small">Merge</div>
            <i className="ri-typhoon-fill fs-5 text-primary cursor-pointer"></i>
          </button>

          <div
            className="d-flex align-items-center gap-2 cursor-pointer"
            onClick={toggleListModal}
          >
            <i
              className="ri-user-line fs-4 text-primary"
              title="Select Customer"
            ></i>
            <div>
              <div className="text-muted small">Customer</div>
              <h6 className="mb-0 fw-bold">
                {selectedCustomer?.firstName || "Select Customer"}
              </h6>
            </div>
          </div>
          {/* <div>
            {Object.keys(orderData).length > 0 ? (
              <Button color="light" size="sm" onClick={toggleKOT}>
                <i className="ri-printer-line"></i>
              </Button>
            ) : null}
          </div> */}
        </CardBody>
      </Card>

      <div
        className="px-lg-4 px-3 py-2 gx-3 gy-4 flex-grow-1 overflow-auto bg-light"
        style={{ minHeight: 0 }}
      >
        {loading ? (
          <Spinner />
        ) : error ? (
          <div className="text-center text-danger">{error}</div>
        ) : selectedTable && !orderData[selectedTable.id] ? (
          <div className="text-center text-muted">
            No orders found for table {selectedTable.tableName}.
          </div>
        ) : filteredOrders.length === 0 ? (
          <div className="text-center text-muted">
            No items for the selected table.
          </div>
        ) : (
          <>
            {filteredOrders?.map((order) =>
              order?.items?.map((item, itemIndex) => {
                const itemKey = `${order?.tableId}-${itemIndex}`;
                const count = itemCounts[itemKey] || item.quantity || 1;
                const isExpanded = expandedItems[itemKey];
                const isSelected = selectedItems.includes(itemKey);

                return (
                  <div
                    key={itemKey}
                    className={`rounded-3 shadow-sm px-2 py-2 mb-2 border border-light-subtle transition-all ${
                      isSelected ? "bg-danger-subtle border-danger" : "bg-white"
                    } ${item?.isLocalItem ? "bg-warning-subtle" : "bg-white"}`}
                    style={{
                      transition: "all 0.3s ease-in-out",
                      cursor: "pointer",
                    }}
                    onClick={() => handleCardClick(itemKey)}
                  >
                    <Row className="align-items-center">
                      <Col xs={3} md={3}>
                        <CardImg
                          src={restro}
                          alt={item.name}
                          className="img-fluid rounded-3"
                          style={{
                            objectFit: "contain",
                            height: "60px",
                            width: "100%",
                            transition: "transform 0.3s",
                          }}
                        />
                      </Col>
                      <Col xs={8} md={9}>
                        <div className="d-flex justify-content-between align-items-center">
                          <h6
                            className={`fw-semibold mb-1 ${
                              item?.children?.length > 0 ||
                              item?.attributes?.length > 0
                                ? "text-secondary"
                                : ""
                            }`}
                            style={{
                              cursor: "pointer",
                              transition: "color 0.3s",
                            }}
                            onClick={(e) => {
                              e.stopPropagation(); // prevent card click
                              toggleChildren(itemKey);
                            }}
                          >
                            {item?.productName}
                            {item?.complimentaryQuantity > 0 && (
                              <span className="ms-2 text-success">
                                🎁 {item.complimentaryQuantity}
                              </span>
                            )}
                          </h6>

                          {/* <input
                            type="checkbox"
                            checked={selectedItems.includes(itemKey)}
                            onChange={() => {
                              handleCheckboxChange(itemKey);
                            }}
                          /> */}
                          <span className="text-muted small">
                            <strong>Qty:</strong> {count}
                          </span>
                        </div>

                        {/* Collapsible children with smooth transition */}
                        <div
                          className="overflow-hidden"
                          style={{
                            maxHeight: isExpanded
                              ? `${item.children?.length * 50}px`
                              : "0px",
                            transition: "max-height 0.3s ease",
                          }}
                        >
                          {item?.children?.map((childItem, indx) => (
                            <div key={childItem.id || indx} className=" mt-2">
                              <div className="d-flex justify-content-between">
                                <small>+ {childItem.productName}</small>
                                <small>{childItem?.productPrice}</small>
                              </div>
                              {childItem?.attributes?.map((attr) => (
                                <small
                                  key={attr.id}
                                  className="text-muted d-block ms-2"
                                >
                                  - {attr.title}
                                </small>
                              ))}
                            </div>
                          ))}
                        </div>

                        {/* Attributes collapsable */}
                        <div
                          className="overflow-hidden"
                          style={{
                            maxHeight: isExpanded
                              ? `${item.attributes?.length * 50}px`
                              : "0px",
                            transition: "max-height 0.3s ease",
                          }}
                        >
                          {item?.attributes?.map((childItem, indx) => (
                            <div key={indx} className=" mt-2">
                              <div className="d-flex justify-content-between">
                                <small>+ {childItem.title}</small>
                                <small>{childItem?.value}</small>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className="d-flex justify-content-between align-content-center align-items-center text-muted mt-2">
                          {/* Show quantity controls for both regular and complementary items */}
                          {(item?.quantity > 0 ||
                            item?.complimentaryQuantity > 0) && (
                            <div className="d-flex justify-content-between align-content-center align-items-center bg-transparent">
                              <div className="input-step border-0 d-flex gap-2 align-items-center bg-transparent">
                                <Button
                                  variant="outline-secondary"
                                  size="sm"
                                  className="rounded-circle"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setItemCounts((prev) => {
                                      const current =
                                        prev[itemKey] !== undefined
                                          ? prev[itemKey]
                                          : item.quantity || 1;
                                      const newCount = Math.max(
                                        1,
                                        Math.min(100, current - 1)
                                      );
                                      setIsQuantityChanged(true);
                                      return { ...prev, [itemKey]: newCount };
                                    });
                                  }}
                                >
                                  −
                                </Button>

                                <input
                                  type="number"
                                  className="form-control form-control-sm text-center w-auto"
                                  value={count}
                                  min="1"
                                  max="100"
                                  style={{
                                    width: "40px",
                                    height: "28px",
                                    fontSize: "12px",
                                    padding: 0,
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                  onChange={(e) => {
                                    let value = parseInt(e.target.value) || 1;
                                    if (value < 1) value = 1;
                                    if (value > 100) value = 100;
                                    setItemCounts((prev) => ({
                                      ...prev,
                                      [itemKey]: value,
                                    }));
                                    setIsQuantityChanged(true);
                                  }}
                                />

                                <Button
                                  variant="outline-secondary"
                                  size="sm"
                                  className="rounded-circle"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setItemCounts((prev) => {
                                      const current =
                                        prev[itemKey] !== undefined
                                          ? prev[itemKey]
                                          : item.quantity || 1;
                                      const newCount = Math.max(
                                        1,
                                        Math.min(100, current + 1)
                                      );
                                      setIsQuantityChanged(true);
                                      return { ...prev, [itemKey]: newCount };
                                    });
                                  }}
                                >
                                  +
                                </Button>
                              </div>
                            </div>
                          )}

                          {/* FIXED: Show total price (unit price × quantity) */}
                          <div className="d-flex flex-column align-items-end">
                            {item?.complimentaryQuantity > 0 ? (
                              // Complimentary => show only FREE text or nothing
                              <span className="fs-14 fw-semibold text-success">
                                FREE
                              </span>
                            ) : item?.attributes?.length > 0 ? (
                              <>
                                {item.attributes.map((attr, idx) => {
                                  const attrPrice = Number(attr.value) || 0;
                                  const basePrice =
                                    Number(item.productPrice) || 0;

                                  // add both if both exist
                                  const effectivePrice =
                                    attrPrice > 0 && basePrice > 0
                                      ? attrPrice + basePrice
                                      : attrPrice > 0
                                      ? attrPrice
                                      : basePrice;

                                  return (
                                    <span
                                      key={idx}
                                      className="fs-14 fw-semibold"
                                    >
                                      Rs. {(effectivePrice * count).toFixed(2)}
                                    </span>
                                  );
                                })}
                              </>
                            ) : (
                              item?.productPrice != null && (
                                <span className="fs-14 fw-semibold">
                                  Rs. {(item.productPrice * count).toFixed(2)}
                                </span>
                              )
                            )}

                            {/* Unit price section */}
                            <small className="text-muted">
                              ({count} × Rs.{" "}
                              {(() => {
                                const attrPrice = item?.attributes?.length
                                  ? Number(item.attributes[0]?.value) || 0
                                  : 0;

                                const basePrice =
                                  Number(item?.productPrice) || 0;

                                const unitPrice =
                                  attrPrice > 0 && basePrice > 0
                                    ? attrPrice + basePrice
                                    : attrPrice > 0
                                    ? attrPrice
                                    : basePrice;

                                return unitPrice.toFixed(2);
                              })()}
                              )
                              {item?.complimentaryQuantity > 0 && (
                                <span className="text-success ms-1">
                                  + {item.complimentaryQuantity} free
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                );
              })
            )}
          </>
        )}
      </div>

      <div className="bg-white sticky-bottom flex-shrink-0 p-3">
        <div
          style={{ border: "1px dashed #e0e0e0", backgroundColor: "#f8f9fa" }}
          className="p-2 rounded-4 mb-3"
        >
          <div className="d-flex justify-content-between fw-bold fs-6 text-success">
            <span>Total</span>
            <span>Rs. {calculateTotals.total.toFixed(2)}</span>
          </div>
        </div>
        <div className="position-relative w-100">
          {selectedItems.length > 0 ? (
            <div className="transition-slide-left active d-flex gap-2">
              <button
                onClick={toggleDeleteModal}
                className="btn btn-soft-danger  w-50 fw-semibold"
              >
                Cancel Selected Order ({selectedItems.length})
              </button>
              <button
                onClick={toggleSwitchItemModal}
                className="btn btn-soft-success  w-50 fw-semibold"
              >
                Switch item ({selectedItems.length})
              </button>
            </div>
          ) : (
            <div className="transition-slide-left ">
              <Row>
                <Col md={12} lg={12} xl={6} className="mb-2">
                  {isQuantityChanged ? (
                    <button
                      className="btn btn-warning fw-semibold w-100"
                      onClick={handlePlaceOrder}
                      disabled={placedLoading}
                    >
                      Update Order
                    </button>
                  ) : (
                    <button
                      className={`btn btn-${orderButtonState.variant} fw-semibold w-100`}
                      onClick={orderButtonState.action}
                      disabled={orderButtonState.disabled || placedLoading}
                    >
                      {orderButtonState.text}
                    </button>
                  )}
                </Col>
                <Col md={12} lg={12} xl={6}>
                  {userRole !== "waiter" ? (
                    // <button
                    //   className="btn btn-light fw-semibold w-100"
                    //   onClick={toggleRightCanvas}
                    //   disabled={
                    //     !isTakeaway &&
                    //     (placedLoading ||
                    //       !selectedTable ||
                    //       !orderData[selectedTable.id] ||
                    //       !orderData[selectedTable.id].orderId)
                    //   }
                    // >
                    //    Process Transaction
                    // </button>
                    <button
                      className="btn btn-light fw-semibold w-100"
                      onClick={() => {
                        // 🔍 Check if any order has isLocalItem === true
                        const hasLocalItem = filteredOrders?.some(
                          (item) => item.isNewItem === true
                        );
                        console.log(
                          "🚀 ~ OrderSummary ~ hasLocalItem:",
                          hasLocalItem
                        );

                        if (hasLocalItem) {
                          toast.error(
                            "Order is not placed. Please first place the order.",
                            {
                              style: {
                                border: "1px solid #E4A11B",
                                padding: "16px",
                                color: "#713200",
                              },
                              iconTheme: {
                                primary: "#E4A11B",
                                secondary: "#FFFAEE",
                              },
                            }
                          );
                          return; // ❌ stop further execution
                        }

                        // ✅ Continue normal flow
                        if (isTakeaway) {
                          setIsRight(true);
                        } else {
                          toggleRightCanvas();
                        }
                      }}
                      disabled={
                        placedLoading ||
                        (!isTakeaway && (!selectedTable || !hasOrderId))
                      }
                    >
                      Process Transaction
                    </button>
                  ) : null}
                </Col>
              </Row>
            </div>
          )}
        </div>
      </div>

      {isRight && calculateTotals.subTotal > 0 && (
        <ConfirmPayment
          isOpen={isRight}
          toggle={toggleRightCanvas}
          handleCheckout={handleCheckout}
          handleUnmergeTable={handleUnmergeTable}
          billData={orderData}
          selectedPayments={selectedPayments}
          setSelectedPayments={setSelectedPayments}
          selectedPayment={selectedPayment}
          setSelectedPayment={setSelectedPayment}
          handleApplyPromo={handleApplyPromo}
          setPromoCode={setPromoCode}
          promoCode={promoCode}
          calculateTotals={calculateTotals}
          handlePercentChange={handlePercentChange}
          handleAmountChange={handleAmountChange}
          discountPercent={discountPercent}
          setDiscountPercent={setDiscountPercent}
          discountAmount={discountAmount}
          setDiscountAmount={setDiscountAmount}
          promoSuccess={promoSuccess}
          setPromoSuccess={setPromoSuccess}
          promoError={promoError}
          setPromoError={setPromoError}
          selectedTable={selectedTable}
          setLastUpdated={setLastUpdated}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          toggleModal={toggleModal}
          orgInfo={orgInfo}
          user={user}
          selectedCustomer={selectedCustomer}
          toggleListModal={toggleListModal}
          creditData={creditData}
          setCreditData={setCreditData}
          setPaymentAmounts={setPaymentAmounts}
          paymentAmounts={paymentAmounts}
          placedItems={placedItems}
          isTakeawayPaymentPending={isTakeawayPaymentPending}
          setIsTakeawayPaymentPending={setIsTakeawayPaymentPending}
          selectedAttributes={selectedAttributes}
          itemPrice={calculateTotals?.subTotal}
        />
      )}

      <CustomerList
        isOpen={isListOpen}
        toggle={toggleListModal}
        setSelectedCustomer={setSelectedCustomer}
        selectedCustomer={selectedCustomer}
      />
      {isBackery && (
        <TableSelect
          isOpen={isTableOpen}
          toggle={toggleTableModal}
          setSelectedTable={setSelectedTable}
          selectedTable={selectedTable}
          data={data}
          sectionData={sectionData}
          setSelectedSection={setSelectedSection}
          selectedSection={selectedSection}
          loading={loading}
          allTables={allTables}
        />
      )}

      <TableSwitch
        isOpen={isSwitchOpen}
        toggle={toggleSwitchModal}
        setSelectedTable={setSelectedTable}
        selectedTable={selectedTable}
        data={data}
        sectionData={sectionData}
        setSelectedSection={setSelectedSection}
        selectedSection={selectedSection}
        loading={loading}
        mode={"switch-table"}
        orderId={orderId}
        fetchOrder={fetchOrder}
        fetchTable={fetchTable}
        allTables={allTables}
      />
      {/* <TableMerge
        isOpen={isMergeOpen}
        toggle={toggleMergeModal}
        setSelectedTable={setSelectedTable}
        selectedTable={selectedTable}
        data={data}
        sectionData={sectionData}
        setSelectedSection={setSelectedSection}
        selectedSection={selectedSection}
        loading={loading}
        mode={"merge-table"}
        orderId={orderId}
        fetchOrder={fetchOrder}
        fetchTable={fetchTable}
      /> */}
      <TableSwitch
        isOpen={isSwitchItemOpen}
        toggle={toggleSwitchItemModal}
        setSelectedTable={setSelectedTable}
        selectedTable={selectedTable}
        data={data}
        sectionData={sectionData}
        setSelectedSection={setSelectedSection}
        selectedSection={selectedSection}
        loading={loading}
        mode={"switch-item"}
        selectedItems={selectedItems}
        fetchOrder={fetchOrder}
        orderData={orderData}
        fetchTable={fetchTable}
        allTables={allTables}
      />

      <TableMerge
        isOpen={isMergeOpen}
        toggle={toggleMergeModal}
        setSelectedTable={setSelectedTable}
        selectedTable={selectedTable}
        data={data}
        sectionData={sectionData}
        setSelectedSection={setSelectedSection}
        selectedSection={selectedSection}
        loading={loading}
        mode="merge-table"
        orderId={orderId}
        selectedItems={selectedItems}
        fetchOrder={fetchOrder}
        fetchTable={fetchTable}
        allTables={allTables}
      />

      <PrintBillModal
        isOpen={showPrintModal}
        toggle={() => setShowPrintModal(false)}
        billData={orderData}
      />
      <CancelOrder
        show={deleteModal}
        onDeleteClick={handleDeleteItem}
        onCloseClick={toggleDeleteModal}
        setRemarks={setRemarks}
        remarks={remarks}
        setTouched={setTouched}
        touched={touched}
        isInvalid={isInvalid}
      />
      <PaymentMethod
        isOpen={isPaymentModal}
        toggle={togglePayment}
        setSelectedPayment={setSelectedPayment}
        selectedPayment={selectedPayment}
      />
      {isModalOpen && (
        <InvoiceBillModal
          isOpen={isModalOpen}
          toggle={toggleModal}
          orgInfo={orgInfo}
          user={user}
          selectedTable={selectedTable}
          orderId={orderId}
          billData={billInfo}
          calculateTotals={totalCalculate}
          responseData={responseData}
          selectedCustomer={invoiceCustomer}
          selectedPayments={invoicePayments}
          userInfo={userInfo}
          placedItems={placedItems}
        />
      )}
      <KOTModal
        isOpen={isKOTOpen}
        toggle={toggleKOT}
        handlePrint={handlePrint}
      />
    </Card>
  );
};

export default OrderSummary;
